import { withBaseProps } from '@hoc/withBaseProps';
import SvgBackground from '@img/hero-background.svg';
import * as React from 'react';
import VariantImage from './Components/VariantImage';
import VariantLinks from './Components/VariantLinks';
import S from './InnerHeroBanner.styles';
export var VariantType;
(function (VariantType) {
    VariantType["Image"] = "image";
    VariantType["Links"] = "links";
})(VariantType || (VariantType = {}));
const InnerHeroBanner = (props) => {
    const renderVariant = () => {
        switch (props.variantType) {
            case VariantType.Image: {
                return React.createElement(VariantImage, { ...props });
            }
            case VariantType.Links: {
                return React.createElement(VariantLinks, { ...props });
            }
            default: {
                return null;
            }
        }
    };
    return (React.createElement(S.Container, { "data-theme": props.theme, "data-variant": props.variantType },
        React.createElement(S.BackgroundLogo, { as: SvgBackground }),
        React.createElement(S.Inner, null, renderVariant())));
};
export default withBaseProps(InnerHeroBanner);
